<template>
    <div class="card">
        <div class="mediaContainer">
            <img @contextmenu.prevent class="content" :src="url"/>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ImageCard",
		props: {
			source: {
				type: String,
				required: true
			}
		},
		computed: {
			url() {
				return require('../assets/' + this.source);
			}
		}
	};
</script>

<style lang="scss" src="../styles/imagecard.scss" scoped/>